import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';

@Injectable()
export class DialogService {

  constructor(private dialog: MatDialog) { }

  open(matDialog: any, data: any = null) {
    const dialogRef = this.dialog.open(matDialog, {
      data: data, disableClose: true
    });
    return dialogRef;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/dialog/dialog.service.ts